export const sectionNames = ["home", "javascript", "exercises", "git"];

export const sectionLabels = {
  exercises: "JS Exercises",
};
